const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class PopularizationOfScience extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.PopularizationOfScience,
            "Each civilization scores culture equal to the amount of science it produces.",
            {}
        )
    }
}

module.exports = PopularizationOfScience;